import { ThemeProvider, createTheme } from "@mui/material/styles";
import "bootstrap/dist/css/bootstrap.css";
import { Route, Switch } from "react-router-dom";
import "./Assets/Styles/app.css";
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header/Header";
import { routes } from "./routes";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import NotFound from "./Pages/NotFound/notFound";
import DisableZoom from "./Components/DisableZoom/DisableZoom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import {
  setCreate_Template,
  setDiscarded,
  setTemplate_Edit,
} from "./Redux/UserSlice/userSlice";
import { ClearImage } from "./Redux/MainImage/imageSlice";
import { deleteAll } from "./Redux/WaterMarks/wateramarks";
import React from "react";

const theme = createTheme({
  palette: {
    secondary: {
      main: "#f25665",
    },
  },
});
function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/edit") {
      Promise.all([
        dispatch(setTemplate_Edit(false)),
        dispatch(setCreate_Template(false)),
        dispatch(ClearImage()),
        dispatch(deleteAll()),
        dispatch(setDiscarded(false)),
      ]);
    }
  }, [location]);

  const getRoutes = (route) => {
    return route?.map((item, i) => <Route exact {...item} key={i} />);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        <Switch>
          {getRoutes(routes)}
          <Route component={NotFound} />
        </Switch>
        <Footer />
        <DisableZoom />
      </div>
    </ThemeProvider>
  );
}

export default App;
